import { render, staticRenderFns } from "./AddUpdateResult.vue?vue&type=template&id=35d24d32"
import script from "./AddUpdateResult.vue?vue&type=script&lang=js"
export * from "./AddUpdateResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports